var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7136 9.20007H18.7117C18.9239 9.20007 19.1273 9.28435 19.2773 9.43436C19.4274 9.58437 19.5116 9.78783 19.5116 9.99998C19.5116 10.2121 19.4274 10.4156 19.2773 10.5656C19.1273 10.7156 18.9239 10.7999 18.7117 10.7999H2.7136C2.50145 10.7999 2.298 10.7156 2.14798 10.5656C1.99797 10.4156 1.9137 10.2121 1.9137 9.99998C1.9137 9.78783 1.99797 9.58437 2.14798 9.43436C2.298 9.28435 2.50145 9.20007 2.7136 9.20007Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04459 10.0001L9.67901 16.6329C9.82921 16.7831 9.91359 16.9868 9.91359 17.1992C9.91359 17.4116 9.82921 17.6154 9.67901 17.7656C9.52881 17.9158 9.32509 18.0001 9.11268 18.0001C8.90026 18.0001 8.69654 17.9158 8.54634 17.7656L1.34719 10.5664C1.27269 10.4921 1.21359 10.4038 1.17327 10.3066C1.13294 10.2095 1.11218 10.1053 1.11218 10.0001C1.11218 9.89486 1.13294 9.79068 1.17327 9.6935C1.21359 9.59631 1.27269 9.50804 1.34719 9.43374L8.54634 2.23458C8.69654 2.08438 8.90026 2 9.11268 2C9.32509 2 9.52881 2.08438 9.67901 2.23458C9.82921 2.38478 9.91359 2.5885 9.91359 2.80092C9.91359 3.01333 9.82921 3.21705 9.67901 3.36725L3.04459 10.0001Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.f80d3f165fa0082e30bb007a4b873aad.svg";
export { ForwardRef as ReactComponent };